import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'ПЕРЕЧЕНЬ СУЩЕСТВУЮЩИХ СТАНДАРТОВ В СФЕРЕ ТУРИСТСКО-ЭКСКУРСИОННОГО ОБСЛУЖИВАНИЯ';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <ol>
                        <li>Общегосударственный классификатор Республики Беларусь «Услуги населению», утвержден и введен
                            в действие постановлением Госстандарта Республики Беларусь от 10 сентября 1997 г. № 11.
                        </li>
                        <li>Стандартизация в сфере туристско-экскурсионного обслуживания. Основные положения. —
                            Государственный стандарт Союза ССР ГОСТ 28681.0-90.
                        </li>
                        <li>Туристско-экскурсионное обслуживание. Проектирование туристских услуг. — Межгосударственный
                            стандарт ГОСТ 28681.1-95.
                        </li>
                        <li>Туристско-экскурсионное обслуживание. Туристские услуги. Общие требования. —
                            Межгосударственный стандарт ГОСТ 28681.2-95.
                        </li>
                        <li>Туристско-экскурсионное обслуживание. Требования по обеспечению безопасности туристов и
                            экскурсантов. — Межгосударственный стандарт ГОСТ 28681.3-95.
                        </li>
                        <li>Туристско-экскурсионное обслуживание. Классификация гостиниц. — Межгосударственный стандарт
                            ГОСТ 28681.4-95.
                        </li>
                        <li>Порядок проведения сертификации туристских услуг. — Государственный стандарт Республики
                            Беларусь СТБ 5.3.01-99.
                        </li>
                        <li>Порядок проведения сертификации гостиничных услуг. — Государственный стандарт Республики
                            Беларусь СТБ 5.3.02-99.
                        </li>
                    </ol>
                </div>
            </div>
        </>
    );
}